export const seoContent = {
	title: "Boom Bots",
	ogTitle: "Boom Bots",
	description: "Boom Bots are onchain automated crypto trading bots. Deploy your bot and stack chips effortlessly.",
  image: "/boom-og-image.png",
};
